<template>
  <div
    class="modal fade"
    id="fast-track-modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <h5 class="modal-title text-white text-bold">
            Modify Fast Track Availability in Frontend
          </h5>
        </div>
        <div class="modal-body bg-white">
          <div>
            <p>
              Below you can select a day until when the Fast Track feature is
              enabled for AND a counter of the number of orders it's available
              for.
            </p>
            <p class="mb-20">
              When one of both independently reaches it's limit (the day after
              the end point or counter = 0) the fast track feature will be
              disabled.
            </p>
            <div class="form-group mb-10">
              <label>Date Fast Track is available until* </label>
              <VueCtkDateTimePicker
                no-label
                v-model="dateAvailableUntil"
                format="YYYY-MM-DD HH:mm:ss"
                outputFormat="YYYY-MM-DD HH:mm:ss"
                formatted="DD.MM.YYYY HH:mm"
                minDate="currentDate"
              />
            </div>
            <div class="form-group mt-10 mb-10">
              <label>Amount of orders before Fast Track is disabled</label>
              <input
                type="number"
                v-model="numberOfOrdersAvailable"
                min="1"
                class="form-control"
              />
            </div>
            <p class="mb-10">
              *Please note, the date / time you select is set in the German
              Timezone which is approximately 6 hours behind Thailand
            </p>
            <p v-if="record_updated">
              <em>
                Fast Track was last updated on
                {{ moment(record_updated).format("DD MMM YYYY HH:mma") }}
              </em>
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ disabled: loading }"
            @click="updateFastTrackAvailability()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: {
    VueCtkDateTimePicker,
  },
  props: [
    "orders_until_disabled",
    "date_until_disabled",
    "record_updated",
    "loading",
  ],
  watch: {
    orders_until_disabled: {
        immediate: true,
        handler(newVal, oldVal) {
            this.numberOfOrdersAvailable = this.orders_until_disabled;
        }
    },
    date_until_disabled: {
        immediate: true,
        handler(newVal, oldVal) {
            this.dateAvailableUntil = this.date_until_disabled;
        }
    },
  },
  data() {
    return {
      currentDate: moment().format("YYYY-MM-DD"),
      dateAvailableUntil: null,
      numberOfOrdersAvailable: null,
    };
  },
  methods: {
    updateFastTrackAvailability() {
      let waiting_reason = $("input[name='waiting_reason']:checked").val();
      let waiting_notes = $("#waiting_notes").val();
      this.$emit("submit", {
        dateAvailableUntil: this.dateAvailableUntil,
        numberOfOrdersAvailable: this.numberOfOrdersAvailable,
      });
    },
  },
};
</script>

<style scoped>
.mt-10 {
  margin-bottom: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
</style>
